<template>
  <el-form class="code-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <!--    <el-form-item>-->
    <!--      <template slot="label">-->
    <!--        类型-->
    <!--      </template>-->
    <!--      <el-select v-model="control.textType">-->
    <!--        <el-option-->
    <!--          v-for="(item, value) in codeTypeList"-->
    <!--          :key="value"-->
    <!--          :label="item.label"-->
    <!--          :value="item.value"-->
    <!--        ></el-option>-->
    <!--      </el-select>-->
    <!--    </el-form-item>-->
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        字段
      </template>
      <normal-select
        style="margin-top: 4px"
        :select-list="selectList"
        :selected-item.sync="control.targetCid"
      ></normal-select>
    </el-form-item>
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        模板
      </template>
      <div>
        <div
          v-if="control.sign && control.templateCode && !_.isEmpty(control.vars)"
          class="template"
        >
          <div>{{ control.sign }}</div>
          <el-button type="text" @click="openTemplate">编辑</el-button>
        </div>
        <el-button v-else type="text" @click="openTemplate">添加模板</el-button>
      </div>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <code-template-dialog
      ref="templateSetting"
      :sign="control.sign"
      :templateCode="control.templateCode"
      :vars="control.vars"
      :varList="varList"
      @submit="changeTemplate"
    ></code-template-dialog>
  </el-form>
</template>

<script>
import { codeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import CodeTemplateDialog from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/codeTemplateDialog"

export default {
  name: "code-control",
  components: { CodeTemplateDialog, NormalSelect },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: {
      type: Object
    }
  },
  data() {
    return {
      codeTypeList
    }
  },
  computed: {
    selectList() {
      return this.sheet.controls
        .filter(control => control._type === "telephone")
        .map(control => ({ label: control.name, value: control._cid }))
    },
    varList() {
      return this.sheet.controls
        .filter(control => ["number", "string"].includes(control._dataType))
        .map(control => ({ label: control.name, value: control._cid }))
    }
  },
  methods: {
    changeTemplate(sign, templateCode, vars) {
      this.$set(this.control, "sign", sign)
      this.$set(this.control, "templateCode", templateCode)
      this.$set(this.control, "vars", vars)
    },
    openTemplate() {
      this.$nextTick(() => {
        this.$refs.templateSetting?.open()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.code-control {
  .template {
    display: flex;
    justify-content: space-between;
    background-color: #ebebeb;
    border-radius: 4px;
    padding: 0 15px;
  }
}
</style>
